
import React, { useRef, useState } from 'react';
import {
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Box,
  Text,
  Flex
} from '@chakra-ui/react';

const SlideToComplete = ({ text, onComplete }) => {
  const [sliderValue, setSliderValue] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);
  const completionTriggered = useRef(false); // Add this ref

  const handleChange = (value) => {
    setSliderValue(value);
    
    // Only trigger completion once when reaching 100
    if (value === 100 && !completionTriggered.current) {
      completionTriggered.current = true;
      setIsCompleted(true);
      onComplete?.();
    } else if (value < 100) {
      completionTriggered.current = false;
    }
  };

  return (
    <Box
      position="relative"
      width="100%"
      height="60px"
      borderRadius="30px"
      bg={isCompleted ? 'green.400' : 'gray.100'}
      transition="background 0.3s ease"
      overflow="hidden"
      p="10px" // Add padding for spacing
      display="flex" // Add this
      alignItems="center" // Add this
    >
      {/* Text overlay */}
      <Flex
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        justifyContent="center"
        alignItems="center"
        zIndex="1"
      >
        <Text
          fontWeight="bold"
          color={isCompleted ? 'white' : 'gray.600'}
          transition="color 0.3s ease"
        >
          {isCompleted ? 'Completed!' : text}
        </Text>
      </Flex>

      {/* Custom slider */}
      <Slider
        value={sliderValue}
        onChange={handleChange}
        min={0}
        max={100}
        isDisabled={isCompleted}
        mx="15px" // Increased margin to contain thumb
        height="40px" // Add this
      >
        <SliderTrack
          bg="transparent"
          height="40px"
          borderRadius="20px"
          overflow="hidden"
        >
          <SliderFilledTrack 
            bg={isCompleted ? 'green.500' : 'green.200'} 
            height="40px"
            borderRadius="20px"
          />
        </SliderTrack>
        
        <SliderThumb
          boxSize="40px"
          borderWidth="2px"
          borderColor="green.400"
          bg="white"
          transition="all 0.2s ease"
          _active={{
            boxShadow: 'none' // Remove shadow when active
          }}
        >
          <Text fontSize="xl" color="green.400" fontWeight="bold">
            ➤
          </Text>
        </SliderThumb>
      </Slider>
    </Box>
  );
};

export default SlideToComplete;